import { LoaderContainer, Dots } from "./Loader.styles"

const Loader = () => {
  return (
    <LoaderContainer>
      <Dots>
        <div></div>
        <div></div>
        <div></div>
      </Dots>
    </LoaderContainer>
  )
}

export default Loader
